function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { useCallback, useMemo } from 'react';
import { buildClassNames } from '../../../modules/css-helpers';
import { addVariant } from '../../../modules/variant-helpers';
import { createOwnUpComponent } from '../../components';
import { getOptionValue, OwnUpOptionBreak } from '../../properties';
import { OwnUpCheckbox } from './single-component';
import { OwnUpCheckBreakStyle, OwnUpCheckGroupStyle } from './style';
/**
 * Check component properties.
 */

var StyledCheckGroup = createOwnUpComponent('div', OwnUpCheckGroupStyle);
var StyledCheckBreak = createOwnUpComponent('hr', OwnUpCheckBreakStyle);
export var OwnUpCheckBreak = function OwnUpCheckBreak(_ref) {
  var className = _ref.className,
      props = _objectWithoutProperties(_ref, ["className"]);

  var builtClass = buildClassNames('ou-check-group__break', className);
  return /*#__PURE__*/React.createElement(StyledCheckBreak, _extends({
    className: builtClass
  }, props));
};
/**
 * A collection of options in which a user may select many.
 *
 * @param props - see {@link OwnUpCheckboxGroupProperties}
 */
// Note: due to parser limitations, generic function args in TSX
//   files cannot use arrows.

export function OwnUpCheckGroup(_ref2) {
  var value = _ref2.value,
      options = _ref2.options,
      className = _ref2.className,
      variant = _ref2.variant,
      _onChange = _ref2.onChange,
      disabled = _ref2.disabled,
      deselect = _ref2.deselect,
      props = _objectWithoutProperties(_ref2, ["value", "options", "className", "variant", "onChange", "disabled", "deselect"]);

  // Extract all the raw values from the options.
  var optionValues = useMemo(function () {
    return value ? value.map(function (x) {
      return getOptionValue(x).value;
    }) : [];
  }, [value]);
  var updateData = useCallback(function (_ref3) {
    var raisedValue = _ref3.value,
        checked = _ref3.checked;

    if (_onChange) {
      var newValue = checked ? [].concat(_toConsumableArray(optionValues || []), [raisedValue]) : optionValues.filter(function (x) {
        return x !== raisedValue;
      });

      _onChange(newValue, optionValues);
    }
  }, [optionValues, _onChange]); // Generate checkbox elements for each item.

  var checkboxes = useMemo(function () {
    var checkBoxCollection = options.map(function (option, index) {
      var key = "check-".concat(index);

      if (option === OwnUpOptionBreak) {
        return /*#__PURE__*/React.createElement(OwnUpCheckBreak, {
          key: key,
          className: className,
          variant: variant
        });
      } // Get the rendering and value properties from the option


      var _getOptionValue = getOptionValue(option),
          optionValue = _getOptionValue.value,
          display = _getOptionValue.display,
          optionVariant = _getOptionValue.variant,
          optionClassName = _getOptionValue.className,
          optionExpansion = _getOptionValue.optionExpansion; // Create the shared property sets.


      var checkProps = {
        variant: addVariant(variant, optionVariant),
        className: buildClassNames(className, optionClassName)
      };
      var isChecked = optionValues.includes(optionValue);
      return /*#__PURE__*/React.createElement(OwnUpCheckbox, _extends({}, checkProps, {
        key: key,
        checked: isChecked,
        value: optionValue,
        disabled: disabled,
        onChange: updateData,
        optionExpansion: optionExpansion
      }), display);
    }); // If the user provided a deselect option, append it to the end.

    if (deselect !== undefined) {
      checkBoxCollection.push( /*#__PURE__*/React.createElement(OwnUpCheckbox, {
        key: "none-of-the-above",
        variant: variant,
        className: className,
        checked: value && value.length === 0,
        disabled: disabled,
        onChange: function onChange() {
          if (_onChange) {
            _onChange([], optionValues);
          }
        }
      }, deselect));
    }

    return checkBoxCollection;
  }, [className, deselect, disabled, _onChange, options, optionValues, updateData, value, variant]);
  var builtClass = useMemo(function () {
    return buildClassNames('ou-check-group', className);
  }, [className]);
  return /*#__PURE__*/React.createElement(StyledCheckGroup, _extends({
    className: builtClass,
    disabled: disabled
  }, props), checkboxes);
}